const localizationConf = {
  locales: ['en']
};

module.exports = localizationConf;
